// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/core/component/community_pool/v1/community_pool.proto (package penumbra.core.component.community_pool.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { AssetId, Value } from "../../../asset/v1/asset_pb.js";

/**
 * CommunityPool parameter data.
 *
 * @generated from message penumbra.core.component.community_pool.v1.CommunityPoolParameters
 */
export const CommunityPoolParameters = proto3.makeMessageType(
  "penumbra.core.component.community_pool.v1.CommunityPoolParameters",
  () => [
    { no: 1, name: "community_pool_spend_proposals_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * CommunityPool genesis state.
 *
 * @generated from message penumbra.core.component.community_pool.v1.GenesisContent
 */
export const GenesisContent = proto3.makeMessageType(
  "penumbra.core.component.community_pool.v1.GenesisContent",
  () => [
    { no: 1, name: "community_pool_params", kind: "message", T: CommunityPoolParameters },
    { no: 2, name: "initial_balance", kind: "message", T: Value },
  ],
);

/**
 * Requests the list of all asset balances associated with the Community Pool.
 *
 * @generated from message penumbra.core.component.community_pool.v1.CommunityPoolAssetBalancesRequest
 */
export const CommunityPoolAssetBalancesRequest = proto3.makeMessageType(
  "penumbra.core.component.community_pool.v1.CommunityPoolAssetBalancesRequest",
  () => [
    { no: 2, name: "asset_ids", kind: "message", T: AssetId, repeated: true },
  ],
);

/**
 * The Community Pool's balance of a single asset.
 *
 * @generated from message penumbra.core.component.community_pool.v1.CommunityPoolAssetBalancesResponse
 */
export const CommunityPoolAssetBalancesResponse = proto3.makeMessageType(
  "penumbra.core.component.community_pool.v1.CommunityPoolAssetBalancesResponse",
  () => [
    { no: 1, name: "balance", kind: "message", T: Value },
  ],
);

